import React from 'react';
import './index.css';
import { render } from 'react-dom';
import { App } from './App';
// Set document title immediately before app renders
document.title = 'Brittney Gwynn';
render(<App data-id="element-141" />, document.getElementById('root'));